import { render } from "./SidebarMenu.vue?vue&type=template&id=3db2ec85"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Sidebar/SidebarMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3db2ec85"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3db2ec85', __exports__)) {
    api.reload('3db2ec85', __exports__)
  }
  
  module.hot.accept("./SidebarMenu.vue?vue&type=template&id=3db2ec85", () => {
    api.rerender('3db2ec85', render)
  })

}


export default __exports__